import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SelectionChangedEvent } from 'ag-grid-enterprise';
import { forkJoin } from 'rxjs';
import { Site, SiteVendor } from 'src/app/classes/models';
import { GenericObject } from 'src/app/interfaces/generic-object';
import { SiteService } from 'src/app/services/site.service';
import { ToastService } from 'src/app/services/toast.service';
import { UtilityService } from 'src/app/services/utility.service';

@Component({
  selector: 'app-assign-sites-to-vendor-modal',
  templateUrl: './assign-sites-to-vendor-modal.component.html',
  styleUrl: './assign-sites-to-vendor-modal.component.less',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class AssignSitesToVendorModalComponent implements OnInit {
  constructor(
    private ToastService: ToastService,
    private SiteService: SiteService,
    private activeModal: NgbActiveModal,
    private UtilityService: UtilityService
  ) {}

  @Input() CompanyId?: number;
  @Input() VendorId: number | null = null;
  @Input() ExemptVendorId: number | null = null;
  @Input() ClientRegisteredVendorId: number | null = null;

  SiteVendors: SiteVendor[] = [];
  suppliedGridQueryData: GenericObject = {};
  disableBtn: boolean = false;

  close(result?: any) {
    this.activeModal.close(result);
  }

  onSelectionChange(event: SelectionChangedEvent) {
    const { api } = event;
    this.SiteVendors = [];

    if (api) {
      const sites: Site[] = api.getSelectedRows();
      sites.forEach((site) => {
        const { id } = site;

        this.SiteVendors.push({
          SiteId: id,
          ExemptVendorId: this.ExemptVendorId,
          ClientRegisteredVendorId: this.ClientRegisteredVendorId,
          VendorId: this.VendorId
        });
      });
    }
  }

  addVendorToSites() {
    if (this.SiteVendors && this.SiteVendors.length === 0) {
      throw this.ToastService.addErrorToast(
        'Error',
        'No vendors selected to assign.'
      );
    }

    this.disableBtn = true;

    forkJoin(
      this.SiteVendors.map((siteVendor) =>
        this.SiteService.saveSiteVendor(siteVendor)
      )
    ).subscribe({
      next: (SiteVendors: SiteVendor[]) => {
        if (SiteVendors) {
          this.ToastService.addSuccessToast(
            'Success',
            'Successfully created Site Vendors.'
          );
          this.close();
        }
      },
      error: (err) => {
        this.ToastService.addErrorToast('Error', err.message, {
          returnError: true
        });
        this.close();
      }
    });
  }

  ngOnInit(): void {
    if (
      !this.VendorId &&
      !this.ExemptVendorId &&
      !this.ClientRegisteredVendorId
    ) {
      this.ToastService.addErrorToast('Error', 'Missing Vendor ID.', {
        returnError: true
      });

      this.close();
    }

    if (!this.CompanyId) {
      this.ToastService.addErrorToast('Error', 'Missing Client ID.', {
        returnError: true
      });

      this.close();
    }

    this.SiteService.getSiteVendors(
      this.UtilityService.stringifyObjectsInQueryObject({
        Site: {
          options: { require: true },
          CompanyId: this.CompanyId
        },
        VendorId: this.VendorId,
        ExemptVendorId: this.ExemptVendorId,
        ClientRegisteredVendorId: this.ClientRegisteredVendorId
      })
    ).subscribe({
      next: (SiteVendors: SiteVendor[]) => {
        const siteIds = SiteVendors.map((sv) => sv.SiteId);
        Object.assign(this.suppliedGridQueryData, {
          CompanyId: this.CompanyId,
          id: { $notIn: siteIds }
        });
      }
    });
  }
}
